import { AppstoreOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { getTriggerTemplates } from "./TriggerTemplates";
import "./DiscordTriggers.css";
import { useEffect, useState } from "react";
import { BotTemplates } from "@dots-projects/types";

// This function returns a random css background-position for template buttons
export const randomBackgroundPosition = () => {
  const num1 = Math.floor(Math.random() * 70);
  const num2 = Math.floor(Math.random() * 70);
  return `${num1}% ${num2}%`;
};

/**
 * Component for trigger template buttons, they open up "new trigger" modal
 */
export default function TemplatesBox({
  backgroundPosition,
  botTemplates,
}: {
  backgroundPosition: string[];
  botTemplates: BotTemplates[];
}) {
  const navigate = useNavigate();
  const triggerButtonStyle =
    "flex items-center rounded-md px-1 py-1 w-48 h-20 cursor-pointer overflow-hidden relative";

  return (
    <div className="flex mb-4 mt-2 p-4 rounded-xl border border-gray-200 overflow-hidden">
      <div className="flex flex-col mr-5 pr-5 border-r border-gray-200">
        <p>Start from scratch</p>
        <div
          className={`${triggerButtonStyle} template-background-img`}
          onClick={() => {
            window.analytics.track("Trigger - new bot from scratch clicked");
            navigate("/automation/new?type=scratch");
          }}
          style={{
            backgroundPosition: backgroundPosition[0],
          }}
        >
          <div className="blob-dark-blue-hover-full">
            <PlusCircleOutlined className="text-lg mr-2" />
            <p className="m-0">New Bot</p>
          </div>
        </div>
      </div>

      <div className="flex flex-col">
        <p>Or pick a template</p>
        <div className="flex gap-5">
          {getTriggerTemplates(
            navigate,
            0,
            3,
            backgroundPosition,
            botTemplates,
            triggerButtonStyle
          )}
          <div
            className={
              "flex items-center rounded-md w-32 h-20 cursor-pointer overflow-hidden relative template-background-img"
            }
            key="more"
            style={{
              backgroundPosition: backgroundPosition[0],
            }}
            onClick={() => {
              window.analytics.track("Trigger - see all trigger templates");
              navigate("/automation/new?type=templates");
            }}
          >
            <div className="blob-dark-blue-hover-full more">
              <AppstoreOutlined />
              <p className="m-0 text-sm mt-1">See All</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
